import Base from 'ember-simple-auth/authenticators/base';
import nameSort from 'scaleflow/utils/nameSort';
import config from 'scaleflow/config/environment';

class BaseAuthenticator extends Base {
  prefixFilter = config.cognito.region;

  tenants(_tenant_ids = []) {
    const tenant_ids = _tenant_ids;
    const usable_tenant_ids = tenant_ids
      .filter((tenant) => {
        if (tenant.toLowerCase().includes(this.prefixFilter?.toLowerCase?.()))
          return false;
        if (tenant.toLowerCase().includes('__')) return false;
        return true;
      })
      .sort((a, b) => nameSort(a, b));
    if (usable_tenant_ids.length === 0)
      console.debug('Could not find a useable tenant');
    return usable_tenant_ids;
  }
}

export default BaseAuthenticator;
